@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.calendar-date-picker {
  line-height: 1;
}

.day-placeholder,
.day-button {
  display: inline-block;
  vertical-align: top;
}

.day-button {
  text-align: center;
  line-height: 20px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  color: @calendar-date-picker--day-button--text-color;

  &.selected {
    background: @calendar-date-picker--day-button--hover--background-color;
    color: @calendar-date-picker--day-button--selected--text-color;

    &:hover {
      background: @calendar-date-picker--day-button--hover--background-color;
    }
  }

  &:hover {
    background: transparent;
    outline: 1px solid @calendar-date-picker--day-button--hover--background-color;
  }

  &:disabled {
    cursor: default;
    color: @calendar-date-picker--day-button--disabled--text-color;

    &:hover {
      color: @calendar-date-picker--day-button--disabled--hover--text-color;
      background: transparent;
      outline: none;
    }

    &.selected {
      background: @calendar-date-picker--day-button--disabled--selected--background-color;
      color: @calendar-date-picker--day-button--disabled--selected--text-color;
    }
  }
}

.icon-wrapper {
  padding: 6px 8px;
}
